import { createFileRoute } from "@tanstack/react-router";
import NeuropathicPainPage from "@/pages/NeuropathicPainPage";
import { buildConditionSchema } from "@/components/ConditionPageLayout";
export const Route = createFileRoute(
  "/neuropathic-pain-treatment-coral-springs-fl",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Neuropathic Pain Treatment Coral Springs Fl | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Neuropathic pain treatment in Coral Springs, FL. Ketamine therapy and supportive care for nerve pain at Neuro Wellness TMS Free consultation available.",
        },
        {
          property: "og:title",
          content:
            "Neuropathic Pain Treatment Coral Springs Fl | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Neuropathic pain treatment in Coral Springs, FL. Ketamine therapy and supportive care for nerve pain at Neuro Wellness TMS Free consultation available.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/neuropathic-pain-treatment-coral-springs-fl",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/neuropathic-pain-treatment-coral-springs-fl",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            buildConditionSchema({
              seoTitle:
                "Ketamine for Neuropathic Pain Treatment Coral Springs, FL | Neuro Wellness TMS Centers of America",
              seoDescription:
                "Targeted IV Ketamine therapy for severe nerve pain, diabetic neuropathy, and post-herpetic neuralgia in Coral Springs, FL. Non-opioid relief.",
              canonical: "/neuropathic-pain-treatment-coral-springs-fl",
              breadcrumbs: [
                { name: "Services", href: "/services-directory" },
                {
                  name: "Conditions Treated",
                  href: "/ketamine-treatment-coral-springs-fl",
                },
                {
                  name: "Neuropathic Pain",
                  href: "/neuropathic-pain-treatment-coral-springs-fl",
                },
              ],
            }),
          ),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <NeuropathicPainPage />;
}
